/**
 * BrasilAPI CNPJ lookup (TTP-243 — Tela 2 acceptance criterion: "consulta
 * BrasilAPI preenchendo razão social/nome fantasia (editáveis); falha da
 * BrasilAPI não bloqueia"). This call is best-effort convenience only — the
 * CNPJ step never waits on it to let the user proceed, and any failure
 * (network, 404 for an unregistered/test CNPJ, malformed response) resolves
 * to `null` rather than throwing.
 */

const BRASILAPI_CNPJ_URL = 'https://brasilapi.com.br/api/cnpj/v1';

export interface BrasilApiCnpjResult {
  legal_name: string;
  trade_name: string | null;
}

interface BrasilApiCnpjResponse {
  razao_social?: unknown;
  nome_fantasia?: unknown;
}

export async function lookupCnpj(cnpjDigits: string): Promise<BrasilApiCnpjResult | null> {
  try {
    const response = await fetch(`${BRASILAPI_CNPJ_URL}/${cnpjDigits}`);
    if (!response.ok) {
      return null;
    }

    const data = (await response.json()) as BrasilApiCnpjResponse;
    const legalName = typeof data.razao_social === 'string' ? data.razao_social.trim() : '';
    if (!legalName) {
      return null;
    }

    const tradeName = typeof data.nome_fantasia === 'string' ? data.nome_fantasia.trim() : '';

    return {
      legal_name: legalName,
      trade_name: tradeName.length > 0 ? tradeName : null,
    };
  } catch {
    return null;
  }
}
